import { signInWithPopup } from './popup'
import { CredentialProvider } from './types'

export const googleProvider: CredentialProvider<void> = {
  id: 'google',

  authenticate() {
    return signInWithPopup('google', firebase => new firebase.auth.GoogleAuthProvider())
  }
}
